var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.close($event)}}},[_c('div',{staticClass:"charalist"},[_c('ul',[_c('li',{staticClass:"back",on:{"click":function($event){return _vm.setdata('back')}}}),_vm._l((_vm.filter),function(value,index){return _c('li',{key:value.Name + index,style:({
          'background-image':
            'url(\'/static/img/weapons/' +
            value.Name +
            '.png\'),url(\'/static/img/weapons/' +
            value.Bg +
            '.png\')',
        }),attrs:{"title":value.Name},on:{"click":function($event){return _vm.setdata(index)}}},[_c('p',[_vm._v(_vm._s(value.Name))])])})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }